// Mise en page des pages légales : une colonne de lecture, et un sommaire
// collant construit à partir des titres h2 du texte (masqué sous 1100 px).
import React, { useEffect, useRef, useState } from "react";

export default function DocumentLegal({ children }) {
	const refArticle = useRef(null);
	const [titres, setTitres] = useState([]);

	useEffect(() => {
		const h2 = Array.from(refArticle.current?.querySelectorAll("h2") || []);
		setTitres(
			h2.map((h, i) => {
				if (!h.id) h.id = `section-${i + 1}`;
				return { id: h.id, texte: h.textContent };
			})
		);
	}, []);

	return (
		<section className="gs-page">
			<div className="gs-conteneur gs-doc">
				<nav className="gs-doc-sommaire" aria-label="Sommaire">
					{titres.map((t) => (
						<a key={t.id} href={`#${t.id}`}>
							{t.texte}
						</a>
					))}
				</nav>
				<article ref={refArticle} className="gs-carte gs-doc-article">
					{children}
				</article>
			</div>
		</section>
	);
}
